module.exports = __webpack_public_path__ + "static/video-c76d19a2855a85f17722d262c185a883.mp4";